import { render, staticRenderFns } from "./luckyCoin.vue?vue&type=template&id=14bc6b2a&"
import script from "./luckyCoin.vue?vue&type=script&lang=js&"
export * from "./luckyCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports